<script>
export default {
  components: {},
  props: {
    data: {
      type: [Object, Array],
      required: true,
    },
    type: {
      type: String,
      required: true // 'pilot' ali 'letalo' ali 'instruktor' ali 'custom'
    }
  },
  emits: ['pilot', 'letalo', 'motorno', 'instruktor', 'namen', 'naloga', 'vrsta', 'pristanek', 'vzlet', 'klub', 'uporabnik', 'letalisca', 'custom', 'novoLetalisce'],
  data() {
    return {
      filterS: '',
    }
  },
  mounted() {

  },
  computed: {
    filterData() {
      const search = this.filterS.toLowerCase();
      if (this.type === 'piloti') {
        return this.data.piloti.filter(p =>
            p.ime.toLowerCase().includes(search) ||
            p.priimek.toLowerCase().includes(search)
        );
      } else if (this.type === 'piloti_vlecni') {
        return this.data.filter(p =>
            p.ime.toLowerCase().includes(search) ||
            p.priimek.toLowerCase().includes(search)
        );
      } else if (this.type === 'instruktor') {
        return this.data.filter(ins =>
            ins.ime.toLowerCase().includes(search) ||
            ins.priimek.toLowerCase().includes(search)
        );
      } else if (this.type === 'letalo') {
        return this.data.filter(l =>
            l.registracija.toLowerCase().includes(search)
        );
      } else if (this.type === 'namen') {
        return this.data.filter(na =>
            na.namen.toLowerCase().includes(search)
        );
      } else if (this.type === 'naloga') {
        return this.data.filter(ng =>
            ng.naloga.toLowerCase().includes(search)
        );
      } else if (this.type === 'pristanek') {
        return this.data.letalisca.filter(pr =>
            pr.icao.toLowerCase().includes(search)
        );
      } else if (this.type === 'vzlet') {
        return this.data.letalisca.filter(vl =>
            vl.icao.toLowerCase().includes(search)
        );
      } else if (this.type === 'klubi') {
        return this.data.filter(kl =>
            kl.naziv.toLowerCase().includes(search)
        );
      } else if (this.type === 'letalisca') {
        return this.data.filter(lte =>
            lte.naziv.toLowerCase().includes(search) || lte.icao.toLowerCase().includes(search)
        );
      } else if (this.type === 'motorno') {
        return this.data.filter(mot =>
            mot.registracija.toLowerCase().includes(search)
        );
      } else if (this.type === 'uporabniki') {
        return this.data.filter(user => user.ime.toLowerCase().includes(search) || user.priimek.toLowerCase().includes(search))
      } else if (this.type === 'v_letala') {
        return this.data.filter(l =>
            l.vrsta_letala.toLowerCase().includes(search)
        );
      } else if (this.type === 'custom') {
        return this.data.filter(item =>
            item.naziv.toLowerCase().includes(search)
        );
      }
      return [];
    },
  },
  methods: {
    selectPilot(id) {
      this.$emit('pilot', id);
      this.filterS = ''; // Po izbiri pilota, počisti filter
      //  console.log("To je iz selecta:", id);
    },
    selectPilotV(id) {
      this.$emit('pilot', id);
      this.filterS = ''; // Po izbiri pilota, počisti filter
      //  console.log("To je iz selecta:", id);
    },
    selectInstruktor(id) {
      this.$emit('instruktor', id);
      this.filterS = ''; // Po izbiri pilota, počisti filter
      //  console.log("To je iz selecta:", id);
    },
    selectLetalo(id) {
      this.$emit('letalo', id);
      this.filterS = ''; // Po izbiri letala, počisti filter
      //  console.log("To je iz selecta:", id);
    },
    selectLetaloVleke(id) {
      this.$emit('motorno', id);
      this.filterS = ''; // Po izbiri letala, počisti filter
      // console.log("To je iz selecta:", id);
    },
    selectNamen(id) {
      this.$emit('namen', id);
      this.filterS = '';
    },
    selectNaloga(id) {
      this.$emit('naloga', id);
      this.filterS = '';
    },
    selectVrstaLet(id) {
      this.$emit('vrsta', id);
      this.filterS = '';
    },
    selectPristanek(id) {
      this.$emit('pristanek', id);
      this.filterS = '';
    },
    selectVzlet(id) {
      this.$emit('vzlet', id);
      this.filterS = '';
    },
    selectKlub(id) {
      this.$emit('klub', id);
      this.filterS = '';
    },
    selectLetalisca(id) {
      this.$emit('letalisca', id);
      this.filterS = '';
    },
    selectUporabnik(id) {
      this.$emit('uporabnik', id);
      this.filterS = ''; // Po izbiri pilota, počisti filter
    },
    selectVLetala(id) {
      this.$emit('letalo', id);
      this.filterS = '';
    },
    selectCustom(id) {
      this.$emit('custom', id);
      this.filterS = '';
    }
  }
}
</script>
<template>
  <div class="p-2 rounded-4">
    <div class="container p-2">
      <i v-if="type !== 'vrsta'" class="fas fa-search text-black shadow"></i> &nbsp;
      <input v-if="type !== 'vrsta'" class="naslov-drop-down p-2 input-dropdown border-0 rounded-3 shadow" placeholder="Išči / Filtriraj" v-model="filterS"/>
      <button v-if="type === 'vzlet' || type === 'pristanek'" class='btn btn-sm btn-outline-warning ms-2 mt-2' @click="$emit('novoLetalisce')"> <i class="fas fa-plus"></i> ICAO</button>
      <div class="notranjost-drop-down container p-2" v-if="type === 'piloti'">
        <div class="p-2 shadow" v-for="(id, index) in filterData" :key="index" @click.prevent="selectPilot(id.id)">{{ id.ime }} {{ id.priimek }} [{{id.klub.substring(0,2).toUpperCase()}}]</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-if="type === 'piloti_vlecni'">
        <div class="p-2 shadow" v-for="(id, index) in filterData" :key="index" @click.prevent="selectPilotV(id.id)">{{ id.ime }} {{ id.priimek }} [{{id.klub.substring(0,2).toUpperCase()}}]</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'instruktor'">
        <div class="p-2 shadow" v-for="(id, index) in filterData" :key="index" @click.prevent="selectInstruktor(id.id)">{{ id.ime }} {{ id.priimek }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'letalo'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectLetalo(id.id)">{{ id.registracija }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'motorno'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectLetaloVleke(id.id)">{{ id.registracija }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'namen'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectNamen(id.id)">{{ id.namen }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'naloga'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectNaloga(id.id)">{{ id.naloga }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'vrsta'">
        <div class="p-2 shadow" v-for="(id, key) in data" :key="key" @click.prevent="selectVrstaLet(id.id)">{{ id.vrsta }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'vzlet'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectVzlet(id.id)">{{ id.icao }} ({{ id.naziv }})</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'pristanek'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectPristanek(id.id)">{{ id.icao }} ({{ id.naziv }})</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'klubi'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectKlub(id.id)">{{ id.naziv }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'letalisca'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectLetalisca(id.id)">{{ id.naziv }} ({{ id.icao }})</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'uporabniki'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectUporabnik(id.id)">{{ id.ime }} {{ id.priimek }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'v_letala'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectVLetala(id.id)">{{ id.vrsta_letala }}</div>
      </div>
      <div class="notranjost-drop-down container p-2" v-else-if="type === 'custom'">
        <div class="p-2 shadow" v-for="(id, key) in filterData" :key="key" @click.prevent="selectCustom(id.id)">{{ id.naziv }}</div>
      </div>
    </div>
  </div>
</template>